import { useState } from "react";
import dynamic from "next/dynamic";
import parse from "html-react-parser";
import { motion } from "framer-motion";

const LazyLoad = dynamic(() => import("../../Image/LazyLoad"));

const TimelineComponent = props => {
	const { block } = props;
	const [activeIndex, setActiveIndex] = useState(0);

	const triggerTimeline = index => {
		setActiveIndex(index);
	};

	const timeLine = {
		active: { opacity: 1 },
		inactive: { opacity: 0 }
	}

	return (
		<div className="customContainer clear">
			{/* Create timeline gallery here */}
			{/* Assets will fade in and out. */}
			<div className="productTimelines">
				<h2 className="cbTitle">{block.data.title}</h2>
				<div className="productTimelinesHolder">
					{block.data.timeLine.map((tl, i) => {
						return (
							<motion.div
								className={`timeline ${activeIndex === i ? "active" : "inactive"}`}
								animate={activeIndex === i ? "active" : "inactive"}
								initial="inactive"
								variants={timeLine}
								key={`timeline-${tl.data.image.id}-${i}`}
								transition={{type: 'tween', duration: 0.5}}
							>
								<LazyLoad
									image={tl.data.image}
									alt={tl.data.title}
								/>
								<div className="contentHolder">
									<div
										className="timelineScroll"
										
									>
										{tl.data.events.map((event, i) => {
											return (
												<div key={i} className="content">
													<h3>{event.title}</h3>
													<div className="copy">
														{event.description
															? parse(
																	event.description
															  )
															: ""}
													</div>
												</div>
											);
										})}
									</div>
								</div>
							</motion.div>
						);
					})}
					<ul className="timelineSteps">
						{block.data.timeLine.map((tl, i) => {
							return (
								<li
									className={`item ${
										activeIndex === i ? "active" : ""
									}`}
									key={`timelineLi-${tl.data.image.id}-${i}`}
									onClick={() => {
										triggerTimeline(i);
									}}
								>
									<div className="icon">
										<span>{tl.data.decade}</span>
									</div>
								</li>
							);
						})}
					</ul>
				</div>
			</div>
		</div>
	);
};

export default TimelineComponent;
